import styled from 'styled-components';

interface ContentProps {
  spacing: number;
}

export const Content = styled.main<ContentProps>`
  padding-top: ${(p) => p.spacing}px;
`;
